﻿// src/modules/registry.ts

export type ModuleKey =
  | "pms"
  | "identity"
  | "identity-management"
  | "settings"
  | "pos"
  | "ems"
  | "voip"
  | "wms"
  | "revenue"
  | "guests"
  | "surveys"
  | "cctv"
  | "support"
  | "keycoder"
  | "garage"
  | "parking-preview";

export type ModuleKind = "internal" | "external" | "placeholder";

export type ModuleDefinition = {
  key: ModuleKey;
  title: string;
  subtitle?: string;
  enabled: boolean; // false = Coming Soon
  order: number;
  kind: ModuleKind;
  externalUrl?: string;
  path?: string;
  showOnDesktop?: boolean;
};

export const MODULES: ModuleDefinition[] = [
  { key: "pms", title: "PMS", enabled: true, order: 1, kind: "internal" },
  // Hidden from the sidebar/module nav — reachable only from the user menu
  // (click on the user's name) and by direct URL.
  { key: "identity", title: "Identity Manager", enabled: true, order: 1.5, kind: "internal", showOnDesktop: false },
  { key: "identity-management", title: "Identity Management", enabled: true, order: 1.6, kind: "internal", showOnDesktop: false },
  { key: "settings", title: "Settings", enabled: true, order: 1.75, kind: "internal", path: "/settings/overview", showOnDesktop: false },
  { key: "pos", title: "POS", enabled: true, order: 2, kind: "internal" },
  { key: "ems", title: "EMS", enabled: true, order: 3, kind: "internal" },
  { key: "voip", title: "VoIP", enabled: true, order: 4, kind: "internal" },
  { key: "wms", title: "WMS", enabled: true, order: 5, kind: "internal" },
  { key: "revenue", title: "Revenue Control", enabled: true, order: 6, kind: "internal" },
  { key: "guests", title: "Guests", enabled: true, order: 7, kind: "internal" },

  {
    key: "cctv",
    title: "CCTV",
    subtitle: "Security Control Center",
    enabled: true,
    order: 8,
    kind: "internal",
  },
  {
    key: "support",
    title: "Support",
    enabled: true,
    order: 9,
    kind: "external",
    externalUrl: "https://reustit-team.atlassian.net/servicedesk/customer/portals",
  },
  {
    key: "keycoder",
    title: "Keycoder",
    subtitle: "Access Control Center",
    enabled: true,
    order: 10,
    kind: "internal",
  },
  {
    key: "garage",
    title: "Garage",
    subtitle: "Parking Control Center",
    enabled: true,
    order: 11,
    kind: "internal",
  },
  {
    key: "parking-preview",
    title: "Parking Preview",
    subtitle: "Local parking UX prototype",
    enabled: true,
    order: 11.5,
    kind: "internal",
  },
  {
    key: "surveys",
    title: "Surveys",
    enabled: true,
    order: 12,
    kind: "external",
    externalUrl:
      "https://www.google.com/search?sca_esv=f553bdcaa43fd66a&sxsrf=ANbL-n5OhpuY6OIocyx5UTadNCIb1Echyw:1770278022895&q=reustit+sp.+z+o.o.&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qOZtNyfWg5Tg6J9rB9dGb7t-24655mPNRe_NVn3zXlMUoU3zRL-_3WPqIb2njJNyv3CwJ-hM%3D&uds=ALYpb_myr09fc72P8O-r9Qptxpsdx5WnR_Gnt2qscQotxxzacWhqNUSOG1ja7nC3omSkjGAwWUcA9rj9S-C4yPjvYuxszYiRt0PeSYa6yccoG0BEjcgvacQ&sa=X&ved=2ahUKEwioj9XF78GSAxUCKBAIHeRAOzwQ3PALegQIOxAF&biw=1536&bih=695&dpr=1.25&aic=0",
  },
];

export const MODULES_BY_KEY = MODULES.reduce((acc, module) => {
  acc[module.key] = module;
  return acc;
}, {} as Record<ModuleKey, ModuleDefinition>);

export function getModuleByKey(key: string): ModuleDefinition | null {
  return MODULES_BY_KEY[key as ModuleKey] ?? null;
}

export function isModuleKey(x: string): x is ModuleKey {
  return Boolean(MODULES_BY_KEY[x as ModuleKey]);
}
